module.exports = __webpack_public_path__ + "static/media/sebastian_1635780905832.9e1a47fe.png";